<section>
    <header class="row page-header">
        <div class="col-sm-12">

            <sp-breadcrumbs>
                <sp-breadcrumb [text]="'Admin'" [routerLink]="'../../'"></sp-breadcrumb>
                <sp-breadcrumb [text]="'Properties'" [routerLink]="'../'"></sp-breadcrumb>
            </sp-breadcrumbs>

            <div class="row">
                <div class="col-sm-12">
                    <a class="btn-back" [routerLink]="['../']"></a>
                    <h2 class="title">{{(property$ | async)?.name}}</h2>
                </div>
            </div>
        </div>
    </header>

    <main>
        <sp-admin-property-details
            *ngIf="property$ | async"
            [property]="property$ | async"
            [workspace]="workspace$ | async"
            (submit)="onSubmit($event)">
        </sp-admin-property-details>
    </main>
</section>
